<template>
  <ionic-vue-page v-bind:title="screenTitle" v-bind:showRefresher="false">
    <v-calendar
      v-bind:attributes="attrs"
      @update:from-page="pageChange"
      @dayclick="showDay"
      is-expanded
      is-dark
      v-bind:min-date="'2019-09-01'"
      v-bind:theme="theme"
    ></v-calendar>

    <div class="ion-text-center">
      <ion-button v-on:click="goToDatePicker()" shape="round" fill="outline">Select unavailability</ion-button>
    </div>

    <div class="ion-text-center">
      <p v-if="shifts.length > 0 && loading === false">Tap on a date to view a shift.</p>
      <p v-if="shifts.length === 0 && loading === false">You have no shifts on this date.</p>
      <p v-if="loading">Loading shifts...</p>
    </div>

    <error-message v-if="error" v-bind:message="error"></error-message>

    <ion-card v-for="(shift, index) in shifts" v-bind:key="index" :color="isCancelled(shift) ? 'danger' : 'dark'">
      <shift-card v-bind:shift="shift" v-bind:products="products"></shift-card>
    </ion-card>
  </ionic-vue-page>
</template>

<script>
import moment from "moment";
import shiftsApiService from "../services/ShiftsApi";
import productsApiService from "../services/ProductsApi";
import Calendar from "v-calendar/lib/components/calendar.umd";
import ShiftCard from "./../components/ShiftCard";
import ShiftUnavailabilityModal from "./../components/ShiftUnavailabilityModal";

const paramDateFormat = "YYYY-MM-DD";

export default {
  name: "Shifts",
  components: {
    "v-calendar": Calendar,
    "shift-card": ShiftCard
  },
  data() {
    return {
      screenTitle: "Shifts",
      savedShifts: [],
      shifts: [],
      products: [],
      error: false,
      loading: false,
      attrs: [
        {
          key: "today",
          bar: {
            color: "red"
          },
          dates: moment().format(paramDateFormat)
        },
        {
          key: "shifts",
          highlight: true,
          dates: []
        },
        {
          key: "cancelled-shifts",
          highlight: "red",
          dates: []
        }
      ],
      theme: {
        // https://github.com/nathanreyes/v-calendar/blob/next/src/utils/defaults/theme.js
        color: "pink",
        container: {
          light: "custom-container",
          dark: "vc-text-gray-200 vc-bg-gray-900 vc-border vc-border-gray-700"
        },
        header: {
          light: "custom-header"
        },
        title: {
          light: "custom-title",
          dark: "custom-title"
        },
        weekdays: {
          light: "custom-weekday"
        },
        navArrows: {
          light:
            "vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600"
        },
        dayContent:
          "custom-day-content vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full"
      }
    };
  },

  async mounted() {
    try {
      this.products = await productsApiService.get();
    } catch (error) {
      this.error = error;
    }
  },

  methods: {
    async pageChange(page) {
      this.showBreakdown = false;
      const loading = await this.$ionic.loadingController.create({
        message: "Loading shifts..."
      });

      loading.present();
      this.loading = true;

      // Build Date from page
      let queryDates = this.buildDatesFromPageEvent(page);

      try {
        const shiftsData = await shiftsApiService.get(
          queryDates.start,
          queryDates.end
        );
        this.savedShifts = shiftsData;
        this.shifts = shiftsData;

        let cancelledShifts = shiftsData.filter(shift => shift.verification_stage === 'CANCELLED');
        let otherShifts = shiftsData.filter(shift => shift.verification_stage !== 'CANCELLED');

        // Attrs have to updated in this way so dates array will update on screen
        const attrs = this.attrs.slice();
        attrs[1].dates = otherShifts.map(shift =>
          moment(shift.start_time).format(paramDateFormat)
        );
        attrs[2].dates = cancelledShifts.map(shift =>
          moment(shift.start_time).format(paramDateFormat)
        );
        this.attrs = attrs;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
        loading.dismiss();
      }
    },

    showDay(event) {
      this.showBreakdown = false;
      this.shifts = this.savedShifts
        .filter(element => element.cellcast_date === event.id)
        .map(element => {
          return Object.assign({}, element);
        });
    },

    buildDatesFromPageEvent(page) {
      const month =
        page.month < 10 ? "0" + page.month.toString() : page.month.toString();
      const startDate = page.year.toString() + "-" + month + "-" + "01";
      const endDate = moment(startDate)
        .endOf("month")
        .format(paramDateFormat);

      return {
        start: startDate,
        end: endDate
      };
    },

    goToDatePicker() {
      return this.$ionic.modalController
        .create({
          component: ShiftUnavailabilityModal
        })
        .then(m => m.present());
    },
    isCancelled(value) {
      return value.verification_stage === 'CANCELLED' ? true : false;
    }
  }
};
</script>

<style scoped>
.vc-day .vc-opacity-0 {
  opacity: 0.5;
}

.vc-day .vc-pointer-events-none {
  pointer-events: all;
}
</style>
